module.exports = {"name":"cardNotifications","audiences":["alphaMembers","allMembers"],"experimentAllocation":{"alphaMembers":1,"allMembers":1},"experimentVersion":"v3","defaultWeight":0,"defaults":{"showCards":false},"variations":[{"name":"showCards","weight":1,"values":{"showCards":true}}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/cardNotifications.json
// module id = i1+E
// module chunks = 1